// Deterministic date formatting for anything that appears in prerendered HTML.
// A bare toLocaleDateString() uses the viewer's locale and time zone, so the
// prerender machine and a visitor can disagree on the text (React hydration
// mismatch #418/#425). Pinning locale and UTC makes both sides identical.
// Returns "" for a missing or unparsable date rather than "Invalid Date".
export function formatDate(value, options) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { timeZone: "UTC", ...options });
}
